import { render, staticRenderFns } from "./DetailedPricingCladding.vue?vue&type=template&id=4fd517d6&scoped=true"
import script from "./DetailedPricingCladding.vue?vue&type=script&lang=js"
export * from "./DetailedPricingCladding.vue?vue&type=script&lang=js"
import style0 from "./DetailedPricingCladding.vue?vue&type=style&index=0&id=4fd517d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd517d6",
  null
  
)

export default component.exports